import {
  CLEAR_MULTIDAY_FORM,
  DELETE_JOB_FROM_MDB,
  EDIT_JOB_INFO_MDB,
  HIDE_CHILD_MISSING_TERMS_POPUP,
  HIDE_JOBS_INVITE_POPUP,
  SELECT_DAYS_MDB,
  SELECT_DEFAULT_INFO_MDB,
  SHOW_CHILD_MISSING_TERMS_POPUP,
  SHOW_JOBS_INVITE_CONFIRMATION_POPUP,
  SHOW_JOBS_INVITE_SELECTION_POPUP,
} from '~/actions';
import { sortDates } from '~/components/Request/multiday/utils';
import { IMultiDayJobInfo } from '~/models';
import { IMultiDayState, TMultiDayAction } from './interface';

const initialState: IMultiDayState = {
  jobDates: null,
  jobInfo: [],
  jobsInvitePopup: {
    showConfirmation: false,
    showSelection: false,
    jobIds: [],
    profession: undefined,
    officeId: '',
  },
  isTCMissing: false,
  isPSAMissing: false,
  officeId: '',
};

export default (state: IMultiDayState = initialState, action: TMultiDayAction): IMultiDayState => {
  switch (action.type) {
    case SELECT_DAYS_MDB:
      return {
        ...state,
        jobDates: sortDates(Object.keys(action.jobData)),
      };

    case SELECT_DEFAULT_INFO_MDB: {
      return {
        ...state,
        jobInfo: (state.jobDates || [])
          .map((localDate: string) => ({ ...action.jobData, localDate }))
          .sort(
            (a: IMultiDayJobInfo, b: IMultiDayJobInfo) =>
              new Date(a.localDate).getTime() - new Date(b.localDate).getTime(),
          ),
        officeId: '',
        isTCMissing: false,
        isPSAMissing: false,
      };
    }
    case DELETE_JOB_FROM_MDB: {
      const { deletedJob } = action;

      const deletedJobIndex = state.jobInfo.findIndex((job) => job.localDate === deletedJob);

      if (deletedJobIndex === -1) {
        return { ...state };
      }

      return {
        ...state,
        jobInfo: [
          ...state.jobInfo.slice(0, deletedJobIndex),
          ...state.jobInfo.slice(deletedJobIndex + 1),
        ],
      };
    }
    case EDIT_JOB_INFO_MDB: {
      const { jobData, jobDate } = action;

      const editJobIndex = state.jobInfo.findIndex((job) => job.localDate === jobDate);

      if (editJobIndex === -1) {
        return state;
      }

      return {
        ...state,
        jobInfo: [
          ...state.jobInfo.slice(0, editJobIndex),
          { ...jobData, localDate: jobDate },
          ...state.jobInfo.slice(editJobIndex + 1),
        ],
      };
    }
    case CLEAR_MULTIDAY_FORM:
    case 'MULTIDAY_BOOKING_INVITE_POST_SUCCESS':
    case 'MULTIDAY_BOOKING_POST_SUCCESS':
      return {
        ...state,
        jobInfo: [],
        jobDates: null,
        isTCMissing: false,
        isPSAMissing: false,
        officeId: '',
      };
    case SHOW_JOBS_INVITE_CONFIRMATION_POPUP: {
      const { jobIds, profession, officeId } = action.payload;
      return {
        ...state,
        jobsInvitePopup: {
          ...state.jobsInvitePopup,
          showConfirmation: true,
          jobIds,
          profession,
          officeId,
        },
      };
    }
    case SHOW_JOBS_INVITE_SELECTION_POPUP:
      return {
        ...state,
        jobsInvitePopup: {
          ...state.jobsInvitePopup,
          showConfirmation: false,
          showSelection: true,
        },
      };
    case HIDE_JOBS_INVITE_POPUP:
      return {
        ...state,
        jobsInvitePopup: {
          ...state.jobsInvitePopup,
          showConfirmation: false,
          showSelection: false,
          jobIds: [],
          profession: undefined,
          officeId: '',
        },
      };

    case SHOW_CHILD_MISSING_TERMS_POPUP: {
      const { payload } = action;
      return {
        ...state,
        isTCMissing: payload.isTCMissing,
        isPSAMissing: payload.isPSAMissing,
        officeId: payload.officeId,
      };
    }
    case HIDE_CHILD_MISSING_TERMS_POPUP: {
      return {
        ...state,
        isTCMissing: false,
        isPSAMissing: false,
        officeId: '',
      };
    }

    default:
      return { ...state };
  }
};
